import { render, staticRenderFns } from "./StoreSelector.vue?vue&type=template&id=0c98c7fe&scoped=true"
import script from "./StoreSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./StoreSelector.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./StoreSelector.vue?vue&type=style&index=0&id=0c98c7fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c98c7fe",
  null
  
)

export default component.exports